import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ComprovanteRendaSelecionarTipoAssinaturaPage } from './comprovante-renda-selecionar-tipo-assinatura.page';

const routes: Routes = [
  {
    path: '',
    component: ComprovanteRendaSelecionarTipoAssinaturaPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ComprovanteRendaSelecionarTipoAssinaturaPageRoutingModule { }
